import { Link, useParams } from 'react-router-dom'
import useAuth from '../hooks/useAuth'
import useAxiosPrivate from '../hooks/useAxiosPrivate'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWarning } from '@fortawesome/free-solid-svg-icons'
import { useEffect } from 'react'

function SchoolNav({active=null, school={}}) {

  const { id } = useParams()

  return (
    <div className="mb-4">
      <div className="bg-white rounded-md shadow-md py-3 px-4 overflow-x-auto">
        <ul className="flex px-0">
          <Link to={`/schools/${id}`} state={school}>
            <li className={`tab-btn ${active === 'details' ? 'active' : ''}`}>
              Details
            </li>
          </Link>
          <Link to={`/schools/${id}/clients`} state={school}>
            <li className={`tab-btn ${active === 'clients' ? 'active' : ''}`}>
              Clients
            </li>
          </Link>    
          <Link to={`/schools/${id}/insurer`} state={school}>
            <li className={`tab-btn ${active === 'insurer' ? 'active' : ''}`}>
              Insurer
            </li>
          </Link>      
        </ul>
      </div>
    </div>
  )

}

export default SchoolNav